import { IFilterItem } from '../../models';
import { Badge, Group, Text } from '@mantine/core';
import { X } from 'tabler-icons-react';

interface Props {
  filter: IFilterItem;
  onRemove: () => void;
}

export const FilterBadge = (props: Props) => {
  return (
    <Badge variant="outline" pr={5} style={{ cursor: 'pointer', textTransform: 'none' }}>
      <Group spacing={5} style={{ flexWrap: 'nowrap' }}>
        <Text size="xs">{props.filter.label}</Text>
        <Group onClick={() => props.onRemove()}>
          <X size={12} style={{ strokeWidth: 3 }} />
        </Group>
      </Group>
    </Badge>
  );
};
